export enum ContractFieldType {
  SIGNATURE = 'SIGNATURE',
  INITIALS = 'INITIALS',
  TEXT = 'TEXT',
  DATE = 'DATE',
  CHECKBOX = 'CHECKBOX',
  DROPDOWN = 'DROPDOWN',
  RADIO = 'RADIO',
  HEADERS = 'HEADERS', // USE THIS FOR THE TITLE OF THE CONTRACT FORM
  NUMBER = 'NUMBER',
  TEXTAREA = 'TEXTAREA',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  IMAGE = 'IMAGE',
  FILE = 'FILE'
}
